import { Helmet } from "react-helmet-async";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../Utils/Axios";
import dayjs from "dayjs";
import DashboardHeader from "./CompanyComponents/DashboardHeaderRouter";
import UrduKeyboard from "../Components/UrduKeyboard";

// Pakistani Fruits List
const pakistaniFruits = [
  { value: 'aam', label: 'آم', labelEn: 'Mango' },
  { value: 'kela', label: 'کیلا', labelEn: 'Banana' },
  { value: 'santara', label: 'سنتارا', labelEn: 'Orange' },
  { value: 'mosambi', label: 'موسمبی', labelEn: 'Sweet Lime' },
  { value: 'malta', label: 'مالٹا', labelEn: 'Malta' },
  { value: 'chikoo', label: 'چیکو', labelEn: 'Sapodilla' },
  { value: 'amrood', label: 'امرود', labelEn: 'Guava' },
  { value: 'anar', label: 'انار', labelEn: 'Pomegranate' },
  { value: 'angoor', label: 'انگور', labelEn: 'Grapes' },
  { value: 'tarbuz', label: 'تربوز', labelEn: 'Watermelon' },
  { value: 'kharbuza', label: 'خربوزہ', labelEn: 'Muskmelon' },
  { value: 'kharbooza', label: 'خربوزہ', labelEn: 'Cantaloupe' },
  { value: 'seb', label: 'سیب', labelEn: 'Apple' },
  { value: 'nashpati', label: 'ناشپاتی', labelEn: 'Pear' },
  { value: 'alubukhara', label: 'آلو بخارا', labelEn: 'Plum' },
  { value: 'khubani', label: 'خوبانی', labelEn: 'Apricot' },
  { value: 'aalu', label: 'آلو', labelEn: 'Potato' },
  { value: 'tamatar', label: 'ٹماٹر', labelEn: 'Tomato' },
  { value: 'kakri', label: 'ککڑی', labelEn: 'Cucumber' },
  { value: 'tori', label: 'ٹوری', labelEn: 'Ridge Gourd' },
  { value: 'lauki', label: 'لوکی', labelEn: 'Bottle Gourd' },
  { value: 'kaddu', label: 'کدو', labelEn: 'Pumpkin' },
  { value: 'bhindi', label: 'بھنڈی', labelEn: 'Okra' },
  { value: 'baingan', label: 'بینگن', labelEn: 'Brinjal' },
  { value: 'shimla_mirch', label: 'شملہ مرچ', labelEn: 'Capsicum' },
  { value: 'gajar', label: 'گاجر', labelEn: 'Carrot' },
  { value: 'mooli', label: 'مولی', labelEn: 'Radish' },
  { value: 'pyaaz', label: 'پیاز', labelEn: 'Onion' },
  { value: 'adrak', label: 'ادرک', labelEn: 'Ginger' },
  { value: 'lehsan', label: 'لہسن', labelEn: 'Garlic' },
  { value: 'palak', label: 'پالک', labelEn: 'Spinach' },
  { value: 'methi', label: 'میتھی', labelEn: 'Fenugreek' },
  { value: 'dhaniya', label: 'دھنیا', labelEn: 'Coriander' },
  { value: 'podina', label: 'پودینہ', labelEn: 'Mint' },
  { value: 'hari_mirch', label: 'ہری مرچ', labelEn: 'Green Chili' },
  { value: 'limoo', label: 'لیمو', labelEn: 'Lemon' },
  { value: 'nimbu', label: 'نیمبو', labelEn: 'Lime' },
  { value: 'kino', label: 'کینو', labelEn: 'Kinnow' },
  { value: 'falsa', label: 'فالسہ', labelEn: 'Phalsa' },
  { value: 'jamun', label: 'جامن', labelEn: 'Java Plum' },
  { value: 'ber', label: 'بیر', labelEn: 'Jujube' },
  { value: 'amla', label: 'آملہ', labelEn: 'Indian Gooseberry' },
  { value: 'sharifa', label: 'شریفہ', labelEn: 'Custard Apple' },
  { value: 'papita', label: 'پپیتا', labelEn: 'Papaya' },
  { value: 'ananas', label: 'انناس', labelEn: 'Pineapple' },
  { value: 'zaitoon', label: 'زیتون', labelEn: 'Olive' },
];

function CreateBill() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editBillId = searchParams.get('edit');
  const isEditMode = !!editBillId;

  const [company, setCompany] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [language, setLanguage] = useState('en');
  const [companyLanguage, setCompanyLanguage] = useState('en');
  const [isSaving, setIsSaving] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("companyToken");
    localStorage.removeItem("companyData");
    toast.success(companyLanguage === 'ur' ? "کامیابی سے لاگ آؤٹ ہو گئے" : "Logged out successfully");
    navigate("/company/login");
  };
  const [expenseFields, setExpenseFields] = useState([]);
  const [salesFields, setSalesFields] = useState([]);
  const [ledgerParties, setLedgerParties] = useState([]);
  const [focusedExpenseField, setFocusedExpenseField] = useState(null);
  const [focusedSalesField, setFocusedSalesField] = useState(null);
  const [selectedCustomerBalance, setSelectedCustomerBalance] = useState(null);
  const [cashAmountError, setCashAmountError] = useState('');
  const [commissionPercentage, setCommissionPercentage] = useState('');
  const [supplierSearchTerm, setSupplierSearchTerm] = useState('');
  const [showSupplierDropdown, setShowSupplierDropdown] = useState(false);
  const [showSupplierUrduKeyboard, setShowSupplierUrduKeyboard] = useState(false);
  const supplierDropdownRef = useRef(null);
  const supplierSearchInputRef = useRef(null);
  const commissionManuallyEditedRef = useRef(false);

  // Refs for Enter key navigation
  const inputRefs = useRef({});

  // Form data - all fields editable
  const [formData, setFormData] = useState({
    serialNumber: '',
    voucherNumber: '',
    customerPartyId: '',
    customerName: '',
    customerNameUrdu: '',
    date: new Date().toLocaleDateString('en-CA'),
    receivedMessage: 'Received, thanks for selling',
    receivedMessageUrdu: '',
    goodsMessage: 'Your goods via consignment/bill of lading',
    goodsMessageUrdu: '',
    vehicleNumber: '', // Bilty number
    actualVehicleNumber: '', // گاڑی نمبر
    itemName: 'kino', // Default to کینو
    itemUnit: '', // units, crates, bags
    itemQuantity: '', // quantity number
    deliveryMethod: '',
    expenses: {},
    sales: {}
  });

  const goodsMessageUrduOptions = ['یونٹس', 'بکس', 'بوریاں'];
  const deliveryMethodOptions = [
    { value: 'crates', label: 'کریٹس (Crates)' },
    { value: 'bags', label: 'بوریاں / بیگز (Bags/Sacks)' },
    { value: 'boxes', label: 'بکس / کارٹن (Boxes/Cartons)' },
    { value: 'pallets', label: 'پیلیٹس (Pallets)' },
    { value: 'loose', label: 'کھلے ٹرک (Loose in Truck)' },
    { value: 'small_van', label: 'ٹرالی / چھوٹی گاڑیاں (Trolley/Small Vans)' },
    { value: 'tractor', label: 'ٹرک/ٹرکٹر ٹرالی (Truck/Tractor)' },
    { value: 'container', label: 'کنٹینر / بڑے ٹرک (Container/Lorry)' },
    { value: 'bulk_bags', label: 'بیگڈ پیکنگ (Bulk Bags)' },
    { value: 'cold_truck', label: 'فریزر / کولر وین (Cold Truck)' },
    { value: 'logistics', label: 'ٹرانسپورٹ کمپنی (Logistics Company)' },
    { value: 'self', label: 'خود لایا گیا (Self Delivery)' },
    { value: 'agent', label: 'کمیشن ایجنٹ کے ذریعے (Via Agent)' }
  ];

  const [dataLoaded, setDataLoaded] = useState(false);
  const billDataFetchedRef = useRef(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        await Promise.all([
          fetchCompanyData(),
          fetchLedgerParties()
        ]);
        setDataLoaded(true);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, [editBillId]);

  // Fetch bill data after company data and ledger parties are loaded (only once)
  useEffect(() => {
    if (editBillId && dataLoaded && !billDataFetchedRef.current) {
      billDataFetchedRef.current = true;
      // Small delay to ensure all state updates are complete
      const timer = setTimeout(() => {
        fetchBillData(editBillId);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [editBillId, dataLoaded]);

  // Close supplier dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (supplierDropdownRef.current && !supplierDropdownRef.current.contains(event.target)) {
        setShowSupplierDropdown(false);
      }
    };

    if (showSupplierDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSupplierDropdown]);

  // Fallback: if for any reason serialNumber/voucherNumber didn't get set by API,
  // ensure they are at least "1" once loading is finished.
  useEffect(() => {
    if (!isLoading && !formData.serialNumber) {
      setFormData(prev => ({ ...prev, serialNumber: '1', voucherNumber: '1' }));
    }
  }, [isLoading, formData.serialNumber, formData.voucherNumber]);

  const fetchCompanyData = async () => {
    try {
      const token = localStorage.getItem("companyToken");
      if (!token) {
        toast.error("Please login");
        navigate("/company/login");
        return;
      }

      const [profileResponse, templateResponse] = await Promise.all([
        api.get("/company/profile", { headers: { Authorization: `Bearer ${token}` } }),
        api.get(`/bill/company/latest-template`, { headers: { Authorization: `Bearer ${token}` } })
      ]);

      setCompany(profileResponse.data.company);
      const companyLang = profileResponse.data.company?.language || 'en';
      setLanguage(companyLang);
      setCompanyLanguage(companyLang);

      if (templateResponse.data.template) {
        const templateExpenseFields = templateResponse.data.template.expenseFields || [];
        const templateSalesFields = templateResponse.data.template.salesFields || [];

        setExpenseFields(templateExpenseFields);
        setSalesFields(templateSalesFields);

        // Only initialize expenses and sales if NOT in edit mode
        if (!editBillId) {
          // Initialize expenses and sales with field names
          const initExpenses = {};
          const initSales = {};
          templateExpenseFields.forEach(field => {
            if (field.fieldName !== 'Vehicle' && field.fieldNameUrdu !== 'گاڑی') {
              initExpenses[field.fieldName] = 0;
            }
          });
          templateSalesFields.forEach(field => {
            initSales[field.fieldName] = 0;
          });
          setFormData(prev => ({
            ...prev,
            expenses: initExpenses,
            sales: initSales
          }));
        }
      }

      // Auto-generate serial number only if NOT in edit mode
      if (!editBillId) {
        // Always ask backend for the latest bill to compute next serial
        const billsResponse = await api.get("/bill/company/my-bills?limit=1", {
          headers: { Authorization: `Bearer ${token}` }
        });

        let nextSerial = 1;
        if (billsResponse.data.bills && billsResponse.data.bills.length > 0) {
          // Find highest valid numeric serial number among existing bills
          // Filter out empty strings and non-numeric values
          const validSerials = billsResponse.data.bills
            .map(bill => {
              const sn = bill.serialNumber?.toString().trim() || '';
              const num = parseInt(sn, 10);
              return !isNaN(num) && num > 0 ? num : null;
            })
            .filter(num => num !== null);

          if (validSerials.length > 0) {
            // Find the maximum serial number
            const maxSerial = Math.max(...validSerials);
            nextSerial = maxSerial + 1;
          } else {
            // If no valid numeric serials, use count-based sequence
            nextSerial = billsResponse.data.bills.length + 1;
          }
        }

        setFormData(prev => ({ ...prev, serialNumber: String(nextSerial), voucherNumber: String(nextSerial) }));
      }
    } catch (error) {
      console.error("Fetch company error:", error);
      toast.error("Failed to load company data");
    }
  };

  const fetchLedgerParties = async () => {
    try {
      const token = localStorage.getItem("companyToken");
      const response = await api.get("/ledger/parties?type=supplier", {
        headers: { Authorization: `Bearer ${token}` }
      });
      // Only fetch suppliers
      setLedgerParties(response.data.parties || []);
    } catch (error) {
      console.error("Fetch ledger parties error:", error);
    }
  };

  const fetchBillData = async (billId) => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("companyToken");
      if (!token) {
        toast.error(language === 'ur' ? 'لاگ ان کریں' : 'Please login');
        navigate('/company/login');
        return;
      }

      const response = await api.get(`/bill/company/${billId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const bill = response.data.bill;
      if (!bill) {
        toast.error(language === 'ur' ? 'بل نہیں ملا' : 'Bill not found');
        navigate('/company/dashboard');
        setIsLoading(false);
        return;
      }

      // Update expense fields from bill if available
      // Ensure Labor and Miscellaneous have Urdu names
      // Remove duplicates - only keep one entry per fieldName
      if (bill.expenseFields && Array.isArray(bill.expenseFields) && bill.expenseFields.length > 0) {
        const seenFieldNames = new Set();
        const fieldsWithUrdu = bill.expenseFields
          .filter(field => {
            // Only keep fields with English fieldName, filter out Urdu-only entries
            if (!field.fieldName || field.fieldName.trim() === '') {
              return false;
            }
            // Remove duplicates - if we've seen this fieldName before, skip it
            if (seenFieldNames.has(field.fieldName)) {
              return false;
            }
            seenFieldNames.add(field.fieldName);
            return true;
          })
          .map(field => {
            // Ensure Labor and Miscellaneous have Urdu names
            if (field.fieldName === 'Labor') {
              return { ...field, fieldNameUrdu: 'مزدوری' };
            } else if (field.fieldName === 'Miscellaneous') {
              return { ...field, fieldNameUrdu: 'مشیانہ' };
            }
            return field;
          });
        setExpenseFields(fieldsWithUrdu);
      }

      if (bill.salesFields && Array.isArray(bill.salesFields) && bill.salesFields.length > 0) {
        setSalesFields(bill.salesFields);
      }

      // Map bill expenses to form data
      // Convert Map to plain object if needed
      let expensesObj = bill.expenses || {};

      // Debug: Log original expenses
      console.log('=== FETCHING BILL DATA ===');
      console.log('Original bill.expenses:', bill.expenses);
      console.log('Type of expenses:', typeof expensesObj, expensesObj instanceof Map);
      console.log('Is Map?', expensesObj instanceof Map);
      console.log('Has forEach?', expensesObj && typeof expensesObj.forEach === 'function');

      if (expensesObj instanceof Map) {
        expensesObj = Object.fromEntries(expensesObj);
        console.log('Converted from Map to object');
      } else if (expensesObj && typeof expensesObj === 'object') {
        // Check if it's a Map-like object
        if (expensesObj.forEach && typeof expensesObj.forEach === 'function') {
          const plainObj = {};
          expensesObj.forEach((val, key) => {
            plainObj[key] = val;
            console.log(`Map entry: ${key} = ${val}`);
          });
          expensesObj = plainObj;
          console.log('Converted from Map-like object using forEach');
        } else if (expensesObj.get && typeof expensesObj.get === 'function') {
          // Try common field names
          const plainObj = {};
          const allPossibleKeys = ['Vehicle', 'Cash', 'Rent', 'Commission', 'Labor', 'Miscellaneous', 'Market Fee', 'Wages', 'Mashiyana', 'نقدی', 'کرایه', 'کمیشن', 'مزدوری', 'مشیانہ', 'مشیانه', 'مارکیٹ فیس'];
          allPossibleKeys.forEach(f => {
            const val = expensesObj.get(f);
            if (val !== undefined && val !== null) {
              plainObj[f] = val;
              console.log(`Got value from Map.get('${f}'): ${val}`);
            }
          });
          expensesObj = plainObj;
          console.log('Converted from Map-like object using get()');
        }
      } else if (!expensesObj || typeof expensesObj !== 'object') {
        expensesObj = {};
        console.log('Expenses was not an object, set to empty object');
      }

      // Debug: Log converted expenses
      console.log('=== CONVERTED EXPENSES ===');
      console.log('Converted expensesObj:', expensesObj);
      console.log('All keys in expensesObj:', Object.keys(expensesObj));
      console.log('Number of keys:', Object.keys(expensesObj).length);

      // Log all key-value pairs
      Object.keys(expensesObj).forEach(key => {
        console.log(`  Key: "${key}" = ${expensesObj[key]} (type: ${typeof expensesObj[key]})`);
      });

      console.log('Labor checks:', {
        'Labor': expensesObj['Labor'],
        'Wages': expensesObj['Wages'],
        'مزدوری': expensesObj['مزدوری']
      });
      console.log('Miscellaneous checks:', {
        'Miscellaneous': expensesObj['Miscellaneous'],
        'Mashiyana': expensesObj['Mashiyana'],
        'مشیانہ': expensesObj['مشیانہ'],
        'مشیانه': expensesObj['مشیانه']
      });

      // Also check all keys to see if there are any variations
      // This helps us find values that might be stored under unexpected keys
      Object.keys(expensesObj).forEach(key => {
        const keyLower = key.toLowerCase();
        if (keyLower.includes('labor') || keyLower.includes('wages') || key === 'مزدوری' || keyLower === 'labor' || keyLower === 'wages') {
          console.log(`✓ Found Labor-related key: "${key}" = ${expensesObj[key]} (type: ${typeof expensesObj[key]})`);
        }
        if (keyLower.includes('miscellaneous') || keyLower.includes('mashiyana') || key === 'مشیانہ' || key === 'مشیانه' || keyLower === 'miscellaneous' || keyLower === 'mashiyana') {
          console.log(`✓ Found Miscellaneous-related key: "${key}" = ${expensesObj[key]} (type: ${typeof expensesObj[key]})`);
        }
      });

      const mappedExpenses = {};

      // First, try to auto-map Labor and Miscellaneous by checking all keys
      // This helps find values stored under unexpected keys
      // Check ALL keys, including those with value 0 (they might be valid)
      const allKeys = Object.keys(expensesObj);
      console.log('All expense keys:', allKeys);
      console.log('All expense key-value pairs:', allKeys.map(k => `${k}: ${expensesObj[k]}`));

      // For Labor: check all possible keys and take the first non-empty value found
      const laborKeys = ['Labor', 'Wages', 'مزدوری'];
      for (const key of laborKeys) {
        const val = expensesObj[key];
        if (val !== undefined && val !== null && val !== '') {
          const numVal = typeof val === 'string' ? parseFloat(val) : val;
          if (!isNaN(numVal) && numVal !== 0) {
            console.log(`Auto-mapping Labor from key "${key}" with value ${numVal}`);
            mappedExpenses['Labor'] = numVal;
            break;
          }
        }
      }
      // If still not found, try case-insensitive search
      if (!mappedExpenses['Labor']) {
        for (const key of allKeys) {
          const keyLower = key.toLowerCase().trim();
          if ((keyLower === 'labor' || keyLower === 'wages') && key !== 'Labor' && key !== 'Wages') {
            const val = expensesObj[key];
            if (val !== undefined && val !== null && val !== '') {
              const numVal = typeof val === 'string' ? parseFloat(val) : val;
              if (!isNaN(numVal) && numVal !== 0) {
                console.log(`Auto-mapping Labor from key "${key}" (case-insensitive) with value ${numVal}`);
                mappedExpenses['Labor'] = numVal;
                break;
              }
            }
          }
        }
      }

      // For Miscellaneous: check all possible keys and take the first non-empty value found
      const miscKeys = ['Miscellaneous', 'Mashiyana', 'مشیانہ', 'مشیانه'];
      for (const key of miscKeys) {
        const val = expensesObj[key];
        if (val !== undefined && val !== null && val !== '') {
          const numVal = typeof val === 'string' ? parseFloat(val) : val;
          if (!isNaN(numVal) && numVal !== 0) {
            console.log(`Auto-mapping Miscellaneous from key "${key}" with value ${numVal}`);
            mappedExpenses['Miscellaneous'] = numVal;
            break;
          }
        }
      }
      // If still not found, try case-insensitive search
      if (!mappedExpenses['Miscellaneous']) {
        for (const key of allKeys) {
          const keyLower = key.toLowerCase().trim();
          if ((keyLower === 'miscellaneous' || keyLower === 'mashiyana') && key !== 'Miscellaneous' && key !== 'Mashiyana') {
            const val = expensesObj[key];
            if (val !== undefined && val !== null && val !== '') {
              const numVal = typeof val === 'string' ? parseFloat(val) : val;
              if (!isNaN(numVal) && numVal !== 0) {
                console.log(`Auto-mapping Miscellaneous from key "${key}" (case-insensitive) with value ${numVal}`);
                mappedExpenses['Miscellaneous'] = numVal;
                break;
              }
            }
          }
        }
      }

      // Use bill's expenseFields if available, otherwise use current expenseFields
      const fieldsToUse = (bill.expenseFields && bill.expenseFields.length > 0) ? bill.expenseFields : expenseFields;
      console.log('Fields to use:', fieldsToUse);

      // Map all expense fields
      if (fieldsToUse.length > 0) {
        fieldsToUse.forEach(field => {
          if (field.fieldName !== 'Vehicle' && field.fieldNameUrdu !== 'گاڑی') {
            // Try multiple key variations in order of priority
            let value = undefined;
            let matchedKey = null;

            // Special handling for Labor and Miscellaneous first
            // Use the auto-mapped values if available, otherwise try to find them
            if (field.fieldName === 'Labor') {
              // First check if we already auto-mapped it
              if (mappedExpenses['Labor'] !== undefined && mappedExpenses['Labor'] !== null && mappedExpenses['Labor'] !== '') {
                value = mappedExpenses['Labor'];
                matchedKey = 'auto-mapped';
                console.log('Using auto-mapped Labor value:', value);
              } else {
                // Try in order: Labor, Wages, مزدوری
                // Check all possible keys and take the first non-zero/non-empty value found
                const possibleKeys = ['Labor', 'Wages', 'مزدوری'];
                for (const key of possibleKeys) {
                  const val = expensesObj[key];
                  if (val !== undefined && val !== null && val !== '') {
                    const numVal = typeof val === 'string' ? parseFloat(val) : val;
                    if (!isNaN(numVal)) {
                      value = numVal;
                      matchedKey = key;
                      console.log('✓ Found Labor value:', value, 'from key:', matchedKey);
                      break;
                    }
                  }
                }
                // If still not found, try to get any value (even 0) from these keys
                if (value === undefined) {
                  for (const key of possibleKeys) {
                    const val = expensesObj[key];
                    if (val !== undefined && val !== null) {
                      const numVal = typeof val === 'string' ? parseFloat(val) : val;
                      if (!isNaN(numVal)) {
                        value = numVal;
                        matchedKey = key;
                        console.log('✓ Found Labor value (including 0):', value, 'from key:', matchedKey);
                        break;
                      }
                    }
                  }
                }
                if (value === undefined) {
                  console.log('✗ Labor value not found. Available keys:', Object.keys(expensesObj));
                  console.log('  Checking each key:');
                  possibleKeys.forEach(k => {
                    console.log(`    "${k}": ${expensesObj[k]} (${typeof expensesObj[k]})`);
                  });
                }
              }
            }
            else if (field.fieldName === 'Miscellaneous') {
              // First check if we already auto-mapped it
              if (mappedExpenses['Miscellaneous'] !== undefined && mappedExpenses['Miscellaneous'] !== null && mappedExpenses['Miscellaneous'] !== '') {
                value = mappedExpenses['Miscellaneous'];
                matchedKey = 'auto-mapped';
                console.log('Using auto-mapped Miscellaneous value:', value);
              } else {
                // Try in order: Miscellaneous, Mashiyana, مشیانہ, مشیانه
                // Check all possible keys and take the first non-zero/non-empty value found
                const possibleKeys = ['Miscellaneous', 'Mashiyana', 'مشیانہ', 'مشیانه'];
                for (const key of possibleKeys) {
                  const val = expensesObj[key];
                  if (val !== undefined && val !== null && val !== '') {
                    const numVal = typeof val === 'string' ? parseFloat(val) : val;
                    if (!isNaN(numVal)) {
                      value = numVal;
                      matchedKey = key;
                      console.log('✓ Found Miscellaneous value:', value, 'from key:', matchedKey);
                      break;
                    }
                  }
                }
                // If still not found, try to get any value (even 0) from these keys
                if (value === undefined) {
                  for (const key of possibleKeys) {
                    const val = expensesObj[key];
                    if (val !== undefined && val !== null) {
                      const numVal = typeof val === 'string' ? parseFloat(val) : val;
                      if (!isNaN(numVal)) {
                        value = numVal;
                        matchedKey = key;
                        console.log('✓ Found Miscellaneous value (including 0):', value, 'from key:', matchedKey);
                        break;
                      }
                    }
                  }
                }
                if (value === undefined) {
                  console.log('✗ Miscellaneous value not found. Available keys:', Object.keys(expensesObj));
                  console.log('  Checking each key:');
                  possibleKeys.forEach(k => {
                    console.log(`    "${k}": ${expensesObj[k]} (${typeof expensesObj[k]})`);
                  });
                }
              }
            }
            // For other fields, try exact English field name first
            else if (expensesObj[field.fieldName] !== undefined && expensesObj[field.fieldName] !== null && expensesObj[field.fieldName] !== '') {
              value = expensesObj[field.fieldName];
              matchedKey = field.fieldName;
            }
            // Try Urdu field name (only if not already found)
            else if (field.fieldNameUrdu && expensesObj[field.fieldNameUrdu] !== undefined && expensesObj[field.fieldNameUrdu] !== null && expensesObj[field.fieldNameUrdu] !== '') {
              value = expensesObj[field.fieldNameUrdu];
              matchedKey = field.fieldNameUrdu;
            }

            // Set the value using English fieldName as key (not Urdu)
            // This ensures we only have one entry per field, using English fieldName
            // Don't overwrite if we already found a value from auto-mapping
            if (!mappedExpenses[field.fieldName] || mappedExpenses[field.fieldName] === 0) {
              if (value !== undefined && value !== null) {
                // Accept 0 as a valid value, only skip empty strings
                const numValue = typeof value === 'string' ? (value === '' ? 0 : parseFloat(value) || 0) : value;
                mappedExpenses[field.fieldName] = numValue;
                console.log(`Mapped ${field.fieldName} to value:`, numValue, 'from original:', value, 'matchedKey:', matchedKey);
              } else if (!mappedExpenses[field.fieldName]) {
                // Only set to 0 if we didn't find any value and haven't set it yet
                mappedExpenses[field.fieldName] = 0;
                console.log(`No value found for ${field.fieldName}, setting to 0`);
              }
            } else {
              console.log(`${field.fieldName} already mapped to:`, mappedExpenses[field.fieldName]);
            }
          }
        });
      } else {
        // Default fields - try all possible key variations
        const defaultFields = [
          { name: 'Cash', urdu: 'نقدی' },
          { name: 'Rent', urdu: 'کرایه' },
          { name: 'Commission', urdu: 'کمیشن' },
          { name: 'Labor', urdu: 'مزدوری', alt: 'Wages' },
          { name: 'Miscellaneous', urdu: 'مشیانہ', alt: 'Mashiyana' },
          { name: 'Market Fee', urdu: 'مارکیٹ فیس' }
        ];

        defaultFields.forEach(field => {
          let value = expensesObj[field.name];
          if ((value === undefined || value === null || value === '') && expensesObj[field.urdu]) {
            value = expensesObj[field.urdu];
          }
          if ((value === undefined || value === null || value === '') && field.alt && expensesObj[field.alt]) {
            value = expensesObj[field.alt];
          }
          mappedExpenses[field.name] = (value !== undefined && value !== null && value !== '') ? (typeof value === 'string' ? parseFloat(value) || 0 : value) : 0;
        });
      }

      // Debug: Log mapped expenses
      console.log('=== FINAL MAPPED EXPENSES ===');
      console.log('Final mappedExpenses:', mappedExpenses);
      console.log('Labor in mappedExpenses:', mappedExpenses['Labor'], '(type:', typeof mappedExpenses['Labor'], ')');
      console.log('Miscellaneous in mappedExpenses:', mappedExpenses['Miscellaneous'], '(type:', typeof mappedExpenses['Miscellaneous'], ')');
      console.log('All mapped expense keys:', Object.keys(mappedExpenses));

      // Set form data with bill data
      const newFormData = {
        serialNumber: bill.serialNumber || '',
        voucherNumber: bill.voucherNumber || bill.serialNumber || '',
        customerPartyId: bill.customerPartyId || '',
        customerName: bill.customerName || '',
        customerNameUrdu: bill.customerNameUrdu || '',
        date: bill.date ? new Date(bill.date).toLocaleDateString('en-CA') : new Date().toLocaleDateString('en-CA'),
        receivedMessage: bill.receivedMessage || 'Received, thanks for selling',
        receivedMessageUrdu: bill.receivedMessageUrdu || '',
        goodsMessage: bill.goodsMessage || 'Your goods via consignment/bill of lading',
        goodsMessageUrdu: bill.goodsMessageUrdu || '',
        vehicleNumber: expensesObj['Vehicle'] || expensesObj['vehicleNumber'] || '',
        actualVehicleNumber: expensesObj['ActualVehicle'] || expensesObj['actualVehicleNumber'] || '',
        itemName: (() => {
          const storedItemName = expensesObj['ItemName'] || expensesObj['itemName'] || '';
          if (!storedItemName) return '';
          // Check if stored value is a label (Urdu or English), convert to value
          const fruitByLabel = pakistaniFruits.find(f => f.label === storedItemName || f.labelEn === storedItemName);
          return fruitByLabel ? fruitByLabel.value : storedItemName;
        })(),
        itemUnit: expensesObj['ItemUnit'] || expensesObj['itemUnit'] || '',
        itemQuantity: expensesObj['ItemQuantity'] || expensesObj['itemQuantity'] || '',
        deliveryMethod: expensesObj['DeliveryMethod'] || expensesObj['deliveryMethod'] || '',
        expenses: mappedExpenses,
        sales: bill.sales || {}
      };

      console.log('=== SETTING FORM DATA ===');
      console.log('Setting formData with expenses:', newFormData.expenses);
      console.log('Labor in formData.expenses:', newFormData.expenses['Labor']);
      console.log('Miscellaneous in formData.expenses:', newFormData.expenses['Miscellaneous']);

      setFormData(newFormData);

      console.log('=== FORM DATA SET ===');

      // Set customer balance if customer is selected
      if (bill.customerPartyId) {
        const party = ledgerParties.find(p => p._id === bill.customerPartyId);
        if (party) {
          setSelectedCustomerBalance(party.currentBalance || 0);
        } else {
          // If party not found in current list, fetch it
          try {
            const partyResponse = await api.get(`/ledger/parties/${bill.customerPartyId}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (partyResponse.data.party) {
              setSelectedCustomerBalance(partyResponse.data.party.currentBalance || 0);
            }
          } catch (err) {
            console.error("Could not fetch party balance:", err);
          }
        }
      }
    } catch (error) {
      console.error("Fetch bill error:", error);
      toast.error(language === 'ur' ? 'بل لوڈ کرنے میں خرابی' : 'Failed to load bill');
      navigate('/company/dashboard');
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleExpenseChange = (fieldName, value) => {
    // Store as string to allow normal editing (including backspace)
    // Only convert to number when field loses focus
    setFormData(prev => ({
      ...prev,
      expenses: {
        ...prev.expenses,
        [fieldName]: value
      }
    }));

    // If user manually edits commission amount, calculate and update percentage
    if (fieldName === 'Commission') {
      commissionManuallyEditedRef.current = true;
      const commissionAmount = value === '' ? 0 : (typeof value === 'number' ? value : parseFloat(value) || 0);
      const rawSaleValue = formData.sales?.['Raw Sale'] || formData.sales?.rawSale || 0;
      const rawSale = rawSaleValue === '' || rawSaleValue === null || rawSaleValue === undefined ? 0 : (typeof rawSaleValue === 'number' ? rawSaleValue : parseFloat(rawSaleValue) || 0);

      if (rawSale > 0 && commissionAmount > 0) {
        // Calculate percentage: (commission / rawSale) * 100
        const calculatedPercentage = (commissionAmount / rawSale) * 100;
        setCommissionPercentage(calculatedPercentage.toFixed(2));
      } else {
        // Clear percentage if commission is 0 or raw sale is 0
        setCommissionPercentage('');
      }
    }

    // Validate cash amount if customer is selected
    if ((fieldName === 'Cash' || fieldName === 'نقدی') && formData.customerPartyId && selectedCustomerBalance !== null) {
      const cashAmount = value === '' ? 0 : (typeof value === 'number' ? value : parseFloat(value) || 0);
      if (cashAmount > selectedCustomerBalance) {
        setCashAmountError(language === 'ur' ? `نقدی کی رقم دستیاب بیلنس (${selectedCustomerBalance.toLocaleString()}) سے زیادہ ہے` : `Cash amount exceeds available balance (${selectedCustomerBalance.toLocaleString()})`);
      } else {
        setCashAmountError('');
      }
    }
  };

  // Handle commission percentage change (based on Raw Sale)
  const handleCommissionPercentageChange = (value) => {
    commissionManuallyEditedRef.current = false; // Reset flag when percentage is changed
    setCommissionPercentage(value);

    // Calculate and update commission amount from Raw Sale
    if (value && value !== '' && !isNaN(parseFloat(value))) {
      const percentage = parseFloat(value);
      if (percentage > 0) {
        const rawSaleValue = formData.sales?.['Raw Sale'] || formData.sales?.rawSale || 0;
        const rawSale = rawSaleValue === '' || rawSaleValue === null || rawSaleValue === undefined ? 0 : (typeof rawSaleValue === 'number' ? rawSaleValue : parseFloat(rawSaleValue) || 0);

        if (rawSale > 0) {
          const commissionAmount = (rawSale * percentage) / 100;
          setFormData(prev => ({
            ...prev,
            expenses: {
              ...prev.expenses,
              Commission: commissionAmount
            }
          }));
        }
      }
    } else {
      // Clear commission if percentage is cleared
      setFormData(prev => ({
        ...prev,
        expenses: {
          ...prev.expenses,
          Commission: 0
        }
      }));
    }
  };

  // Auto-update commission when Raw Sale changes (only if percentage is set and commission wasn't manually edited)
  useEffect(() => {
    // Skip if commission was manually edited
    if (commissionManuallyEditedRef.current) {
      return;
    }

    if (commissionPercentage && commissionPercentage !== '' && !isNaN(parseFloat(commissionPercentage))) {
      const percentage = parseFloat(commissionPercentage);
      if (percentage > 0) {
        const rawSaleValue = formData.sales?.['Raw Sale'] || formData.sales?.rawSale || 0;
        const rawSale = rawSaleValue === '' || rawSaleValue === null || rawSaleValue === undefined ? 0 : (typeof rawSaleValue === 'number' ? rawSaleValue : parseFloat(rawSaleValue) || 0);

        if (rawSale > 0) {
          const commissionAmount = (rawSale * percentage) / 100;
          // Only update if different to avoid infinite loops
          const currentCommission = formData.expenses?.['Commission'] || 0;
          const currentCommissionNum = currentCommission === '' || currentCommission === null || currentCommission === undefined ? 0 : (typeof currentCommission === 'number' ? currentCommission : parseFloat(currentCommission) || 0);

          if (Math.abs(currentCommissionNum - commissionAmount) > 0.01) {
            setFormData(prev => ({
              ...prev,
              expenses: {
                ...prev.expenses,
                Commission: commissionAmount
              }
            }));
          }
        }
      }
    }
  }, [commissionPercentage, formData.sales]);

  const handleSalesChange = (fieldName, value) => {
    // Store as string to allow normal editing (including backspace)
    // Only convert to number when field loses focus
    setFormData(prev => ({
      ...prev,
      sales: {
        ...prev.sales,
        [fieldName]: value
      }
    }));
  };

  const handleExpenseFocus = (fieldName) => {
    setFocusedExpenseField(fieldName);
    // Clear the field if it's 0, but keep as string to allow normal editing
    const currentValue = formData.expenses[fieldName];
    if (currentValue === 0 || currentValue === '0') {
      setFormData(prev => ({
        ...prev,
        expenses: {
          ...prev.expenses,
          [fieldName]: ''
        }
      }));
    } else if (typeof currentValue === 'number') {
      // Convert number to string for editing
      setFormData(prev => ({
        ...prev,
        expenses: {
          ...prev.expenses,
          [fieldName]: currentValue.toString()
        }
      }));
    }
  };

  const handleExpenseBlur = (fieldName) => {
    setFocusedExpenseField(null);
    // Convert to number when field loses focus
    const currentValue = formData.expenses[fieldName];
    if (currentValue === '' || currentValue === null || currentValue === undefined) {
      setFormData(prev => ({
        ...prev,
        expenses: {
          ...prev.expenses,
          [fieldName]: 0
        }
      }));
    } else if (typeof currentValue === 'string' && currentValue.trim() !== '') {
      // Convert string to number
      const numValue = parseFloat(currentValue) || 0;
      setFormData(prev => ({
        ...prev,
        expenses: {
          ...prev.expenses,
          [fieldName]: numValue
        }
      }));
    }
  };

  const handleSalesFocus = (fieldName) => {
    setFocusedSalesField(fieldName);
    // Clear the field if it's 0, but keep as string to allow normal editing
    const currentValue = formData.sales[fieldName];
    if (currentValue === 0 || currentValue === '0') {
      setFormData(prev => ({
        ...prev,
        sales: {
          ...prev.sales,
          [fieldName]: ''
        }
      }));
    } else if (typeof currentValue === 'number') {
      // Convert number to string for editing
      setFormData(prev => ({
        ...prev,
        sales: {
          ...prev.sales,
          [fieldName]: currentValue.toString()
        }
      }));
    }
  };

  const handleSalesBlur = (fieldName) => {
    setFocusedSalesField(null);
    // Convert to number when field loses focus
    const currentValue = formData.sales[fieldName];
    if (currentValue === '' || currentValue === null || currentValue === undefined) {
      setFormData(prev => ({
        ...prev,
        sales: {
          ...prev.sales,
          [fieldName]: 0
        }
      }));
    } else if (typeof currentValue === 'string' && currentValue.trim() !== '') {
      // Convert string to number
      const numValue = parseFloat(currentValue) || 0;
      setFormData(prev => ({
        ...prev,
        sales: {
          ...prev.sales,
          [fieldName]: numValue
        }
      }));
    }
  };

  // Function to move to next field on Enter key
  const moveToNextField = (currentFieldKey) => {
    // Base field sequence (before expense fields)
    const baseSequence = [
      'actualVehicleNumber',  // گاڑی نمبر
      'vehicleNumber',        // بیلٹی نمبر
      'itemName',             // چیز کا نام (select)
      'itemUnit',             // یونٹ (select)
      'itemQuantity'          // مقدار
    ];

    // Get expense fields sequence
    let expenseFieldNames = [];
    if (expenseFields.length > 0) {
      expenseFieldNames = expenseFields
        .filter(f => f.fieldName !== 'Vehicle' && f.fieldNameUrdu !== 'گاڑی')
        .map(f => f.fieldName);
    } else {
      // Default expense fields
      expenseFieldNames = ['Cash', 'Rent', 'Commission', 'Labor', 'Miscellaneous', 'Market Fee'];
    }

    // Get sales fields sequence
    let salesFieldNames = [];
    if (salesFields.length > 0) {
      salesFieldNames = salesFields.map(f => f.fieldName);
    } else {
      // Default sales fields
      salesFieldNames = ['Raw Sale'];
    }

    // Combine base sequence with expense fields, then sales fields
    const fieldSequence = [...baseSequence, ...expenseFieldNames, ...salesFieldNames];

    const currentIndex = fieldSequence.indexOf(currentFieldKey);
    if (currentIndex >= 0 && currentIndex < fieldSequence.length - 1) {
      const nextFieldKey = fieldSequence[currentIndex + 1];
      const nextRef = inputRefs.current[nextFieldKey];

      if (nextRef) {
        setTimeout(() => {
          nextRef.focus();
          if (nextRef.select) {
            nextRef.select();
          }
        }, 10);
      }
    }
  };

  // Handle Urdu keyboard input for supplier search
  const handleSupplierSearchUrduKeyPress = (key) => {
    if (key === 'backspace') {
      setSupplierSearchTerm(prev => prev ? prev.slice(0, -1) : '');
    } else {
      setSupplierSearchTerm(prev => (prev || '') + key);
      setShowSupplierDropdown(true);
    }
  };

  // Toggle Urdu keyboard on supplier search input click
  const handleSupplierSearchInputClick = () => {
    setShowSupplierUrduKeyboard(prev => !prev);
  };

  const handleCustomerSelect = async (partyId) => {
    const party = ledgerParties.find(p => p._id === partyId);
    if (party) {
      setFormData(prev => ({
        ...prev,
        customerPartyId: partyId,
        customerName: party.name,
        customerNameUrdu: party.nameUrdu || party.name
      }));

      // Fetch customer's current balance from ledger parties list
      const balance = party.currentBalance || 0;
      setSelectedCustomerBalance(balance);

      // Validate current cash amount if already entered
      const currentCash = parseFloat(formData.expenses?.Cash || formData.expenses?.['نقدی'] || 0);
      if (currentCash > balance) {
        setCashAmountError(language === 'ur' ? `نقدی کی رقم دستیاب بیلنس (${balance.toLocaleString()}) سے زیادہ ہے` : `Cash amount exceeds available balance (${balance.toLocaleString()})`);
      } else {
        setCashAmountError('');
      }
    } else {
      setSelectedCustomerBalance(null);
      setCashAmountError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate supplier is selected
    if (!formData.customerPartyId) {
      toast.error(language === 'ur' ? 'براہ کرم سپلائر منتخب کریں' : 'Please select a supplier');
      setIsSaving(false);
      return;
    }

    // Validate cash amount before submitting
    if (formData.customerPartyId) {
      const cashAmount = parseFloat(formData.expenses?.Cash || formData.expenses?.['نقدی'] || 0);
      if (cashAmount > selectedCustomerBalance) {
        toast.error(language === 'ur' ? `نقدی کی رقم دستیاب بیلنس (${selectedCustomerBalance.toLocaleString()}) سے زیادہ ہے` : `Cash amount exceeds available balance (${selectedCustomerBalance.toLocaleString()})`);
        setIsSaving(false);
        return;
      }
    }

    try {
      setIsSaving(true);
      const token = localStorage.getItem("companyToken");

      // Prepare expenses with Vehicle (bilty), ActualVehicle (گاڑی نمبر), ItemName, DeliveryMethod and GoodsMessageUrdu
      // Convert empty strings to 0 for numeric fields
      // Only use fieldName (English) as keys, not Urdu names
      // IMPORTANT: When updating, we need to remove old English/Urdu duplicate keys
      const cleanedExpenses = {};

      // Map expenses using expenseFields to ensure we only use English fieldName as keys
      expenseFields.forEach(field => {
        if (field.fieldName !== 'Vehicle' && field.fieldNameUrdu !== 'گاڑی') {
          const value = formData.expenses[field.fieldName];
          if (value === '' || value === null || value === undefined) {
            cleanedExpenses[field.fieldName] = 0;
          } else {
            cleanedExpenses[field.fieldName] = typeof value === 'number' ? value : (parseFloat(value) || 0);
          }
        }
      });

      // If expenseFields is empty, use formData.expenses but filter out Urdu keys
      if (expenseFields.length === 0) {
        Object.keys(formData.expenses).forEach(key => {
          // Only include English keys, exclude Urdu keys
          const isUrduKey = /[\u0600-\u06FF]/.test(key); // Check if key contains Arabic/Urdu characters
          if (!isUrduKey && key !== 'Vehicle' && key !== 'ActualVehicle' && key !== 'ItemName' && key !== 'ItemUnit' && key !== 'ItemQuantity' && key !== 'DeliveryMethod' && key !== 'GoodsMessageUrdu') {
            const value = formData.expenses[key];
            if (value === '' || value === null || value === undefined) {
              cleanedExpenses[key] = 0;
            } else {
              cleanedExpenses[key] = typeof value === 'number' ? value : (parseFloat(value) || 0);
            }
          }
        });
      }

      // When updating, explicitly remove old duplicate keys (Wages, Mashiyana, Urdu keys)
      // to prevent showing both English and Urdu fields in bill view
      const keysToRemove = ['Wages', 'Mashiyana', 'مزدوری', 'مشیانہ', 'مشیانه'];
      keysToRemove.forEach(key => {
        delete cleanedExpenses[key];
      });

      // Convert itemName value to label for storage
      const fruit = pakistaniFruits.find(f => f.value === formData.itemName);
      const itemNameForStorage = fruit ? (isUrdu ? fruit.label : fruit.labelEn) : formData.itemName;

      const finalExpenses = {
        ...cleanedExpenses,
        Vehicle: formData.vehicleNumber, // Bilty number
        ActualVehicle: formData.actualVehicleNumber, // گاڑی نمبر
        ItemName: itemNameForStorage,
        ItemUnit: formData.itemUnit, // units, crates, bags
        ItemQuantity: formData.itemQuantity || '', // quantity number
        DeliveryMethod: formData.deliveryMethod,
        GoodsMessageUrdu: formData.goodsMessageUrdu
      };

      // Clean sales data as well
      const cleanedSales = {};
      Object.keys(formData.sales).forEach(key => {
        const value = formData.sales[key];
        if (value === '' || value === null || value === undefined) {
          cleanedSales[key] = 0;
        } else {
          cleanedSales[key] = typeof value === 'number' ? value : (parseFloat(value) || 0);
        }
      });

      // Ensure expenseFields have Urdu names, especially for Labor and Miscellaneous
      const expenseFieldsToSave = expenseFields.map(field => {
        if (field.fieldName === 'Labor') {
          return { ...field, fieldNameUrdu: 'مزدوری' };
        } else if (field.fieldName === 'Miscellaneous') {
          return { ...field, fieldNameUrdu: 'مشیانہ' };
        }
        return field;
      });

      const billPayload = {
        serialNumber: formData.serialNumber,
        voucherNumber: formData.voucherNumber || formData.serialNumber,
        customerPartyId: formData.customerPartyId,
        customerName: formData.customerName,
        customerNameUrdu: formData.customerNameUrdu,
        date: formData.date,
        receivedMessage: formData.receivedMessage,
        receivedMessageUrdu: formData.receivedMessageUrdu,
        goodsMessage: formData.goodsMessage,
        goodsMessageUrdu: formData.goodsMessageUrdu,
        expenses: finalExpenses,
        sales: cleanedSales,
        expenseFields: expenseFieldsToSave,
        salesFields: salesFields
      };

      let response;
      let createdBill;

      if (isEditMode && editBillId) {
        // Update existing bill
        response = await api.put(`/bill/company/${editBillId}`, billPayload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        createdBill = response.data?.bill;
      } else {
        // Create new bill
        response = await api.post("/bill/company/create", billPayload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        createdBill = response.data?.bill;
      }

      // Note: Ledger transactions are automatically created by the backend when bill is created
      // No need to create them here to avoid duplicates

      toast.success(language === 'ur' ? (isEditMode ? 'بل تبدیل ہو گیا!' : 'بل بن گیا!') : (isEditMode ? "Bill updated successfully!" : "Bill created successfully!"));
      navigate(`/bill/view/${createdBill._id}`);
    } catch (error) {
      console.error("Create bill error:", error);
      toast.error(error.response?.data?.message || "Failed to create bill");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  const showBoth = language === 'both';
  const isUrdu = language === 'ur' || showBoth;
  const isEnglish = language === 'en' || showBoth;

  // Calculate totals
  // First calculate expenses excluding commission (to avoid circular dependency)
  let totalExpensesExcludingCommission = 0;
  if (formData.expenses) {
    Object.keys(formData.expenses).forEach(key => {
      const value = formData.expenses[key];
      // Handle empty string, null, undefined as 0
      const numValue = value === '' || value === null || value === undefined ? 0 : (typeof value === 'number' ? value : parseFloat(value) || 0);
      // Exclude commission from this calculation
      if (key !== 'Vehicle' && key !== 'ItemName' && key !== 'DeliveryMethod' && key !== 'ActualVehicle' && key !== 'Commission' && !isNaN(numValue)) {
        totalExpensesExcludingCommission += numValue;
      }
    });
  }

  const rawSaleValue = formData.sales?.['Raw Sale'] || formData.sales?.rawSale || 0;
  const rawSale = rawSaleValue === '' || rawSaleValue === null || rawSaleValue === undefined ? 0 : (typeof rawSaleValue === 'number' ? rawSaleValue : parseFloat(rawSaleValue) || 0);

  // Calculate net sale before commission
  const netSaleBeforeCommission = rawSale - totalExpensesExcludingCommission;

  // Calculate commission from percentage if provided (based on Raw Sale, not Net Sale)
  let calculatedCommission = 0;
  if (commissionPercentage && commissionPercentage !== '' && !isNaN(parseFloat(commissionPercentage))) {
    const percentage = parseFloat(commissionPercentage);
    if (percentage > 0 && rawSale > 0) {
      calculatedCommission = (rawSale * percentage) / 100;
    }
  } else {
    // Use manual commission amount if percentage not set
    const commissionValue = formData.expenses?.['Commission'] || 0;
    calculatedCommission = commissionValue === '' || commissionValue === null || commissionValue === undefined ? 0 : (typeof commissionValue === 'number' ? commissionValue : parseFloat(commissionValue) || 0);
  }

  // Final totals
  const totalExpenses = totalExpensesExcludingCommission + calculatedCommission;
  const netSale = netSaleBeforeCommission - calculatedCommission;

  return (
    <>
      {/* Company Header - Fixed at Top */}
      {/* {company && (
        <DashboardHeader 
          company={company} 
          companyLanguage={companyLanguage} 
          onLogout={handleLogout} 
        />
      )} */}

      <Helmet>
        <title>{language === 'ur' ? (isEditMode ? 'بل تبدیل کریں' : 'نیا بل بنائیں') : (isEditMode ? 'Edit Bill' : 'Create New Bill')}</title>
      </Helmet>
      <div className="min-h-screen bg-gray-100 pt-[6px] pb-8 px-4">
        <div className="max-w-4xl mx-auto bg-white shadow-lg border-l-4 border-r-4 border-black">
          <form onSubmit={handleSubmit}>
            {/* Header Image */}
            {company?.headerImage && (
              <div className="w-full" style={{ height: '196px', overflow: 'hidden' }}>
                <img
                  src={company.headerImage}
                  alt="Header"
                  className="w-full h-full object-cover"
                  style={{ width: '1200px', height: '196px', objectFit: 'cover' }}
                />
              </div>
            )}

            {/* Top Section */}
            <div className="grid md:grid-cols-2 gap-6 p-6 border-b border-gray-300 overflow-hidden">
              {/* Left Side - Date and Received Message */}
              <div className="min-w-0 overflow-hidden">
                <div className="mb-3">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {isEnglish && (showBoth ? 'Date / ' : '')}
                    {isUrdu && 'تاریخ -'}
                  </label>
                  <input
                    type="date"
                    value={formData.date}
                    onChange={(e) => handleInputChange('date', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-gray-700"
                    required
                  />
                </div>
              </div>

              {/* Right Side - Serial, Customer, Bilty, Item, Delivery */}
              <div className="text-right min-w-0 overflow-hidden pr-2" dir="rtl">
                {/* Serial Number (auto-generated, read-only) */}
                <div className="mb-3">
                  <div className="text-gray-700 mb-1">
                    <strong>{isUrdu && 'سیریل نمبر -'}</strong>{' '}
                    <input
                      type="text"
                      value={formData.serialNumber}
                      readOnly
                      className="inline-block w-[150px] max-w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right bg-gray-100 cursor-not-allowed"
                      dir="rtl"
                    />
                  </div>
                </div>

                {/* Voucher Number (auto-generated, read-only) */}
                <div className="mb-3">
                  <div className="text-gray-700 mb-1">
                    <strong>{isUrdu && 'واؤچر نمبر -'}</strong>{' '}
                    <input
                      type="text"
                      value={formData.voucherNumber}
                      readOnly
                      className="inline-block w-[150px] max-w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right bg-gray-100 cursor-not-allowed"
                      dir="rtl"
                    />
                  </div>
                </div>

                {/* Supplier Dropdown + Optional Text */}
                <div className="mb-3">
                  <div className="text-gray-700 mb-1">
                    <strong>{isUrdu && 'سپلائر کا نام -'}</strong>{' '}
                    <div className="relative inline-block w-[200px] max-w-full" ref={supplierDropdownRef}>
                      <input
                        ref={supplierSearchInputRef}
                        type="text"
                        value={formData.customerPartyId ? (ledgerParties.find(p => p._id === formData.customerPartyId)?.nameUrdu || ledgerParties.find(p => p._id === formData.customerPartyId)?.name || '') : supplierSearchTerm}
                        onChange={(e) => {
                          setSupplierSearchTerm(e.target.value);
                          setShowSupplierDropdown(true);
                          if (!e.target.value) {
                            handleCustomerSelect('');
                          }
                        }}
                        onClick={handleSupplierSearchInputClick}
                        onFocus={() => setShowSupplierDropdown(true)}
                        className="inline-block w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right"
                        dir="rtl"
                        placeholder={isUrdu ? 'سپلائر تلاش کریں...' : 'Search supplier...'}
                        style={isUrdu ? {
                          fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif",
                          lineHeight: '1.8',
                          paddingTop: '12px',
                          paddingBottom: '12px',
                          fontSize: '13px',
                          height: 'auto',
                          minHeight: '44px',
                          verticalAlign: 'middle',
                          overflow: 'visible'
                        } : {}}
                      />
                      {showSupplierDropdown && (
                        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded shadow-lg max-h-60 overflow-y-auto" dir="rtl">
                          {ledgerParties
                            .filter(p => p.type === 'supplier')
                            .filter(party => {
                              const searchLower = supplierSearchTerm.toLowerCase();
                              const nameLower = (party.name || '').toLowerCase();
                              const nameUrduLower = (party.nameUrdu || '').toLowerCase();
                              return nameLower.includes(searchLower) || nameUrduLower.includes(searchLower);
                            })
                            .map(party => (
                              <div
                                key={party._id}
                                onClick={() => {
                                  handleCustomerSelect(party._id);
                                  setSupplierSearchTerm('');
                                  setShowSupplierDropdown(false);
                                }}
                                className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-gray-700 text-right border-b border-gray-100 last:border-b-0"
                              >
                                {party.nameUrdu || party.name}
                              </div>
                            ))}
                          {ledgerParties.filter(p => p.type === 'supplier').filter(party => {
                            const searchLower = supplierSearchTerm.toLowerCase();
                            const nameLower = (party.name || '').toLowerCase();
                            const nameUrduLower = (party.nameUrdu || '').toLowerCase();
                            return nameLower.includes(searchLower) || nameUrduLower.includes(searchLower);
                          }).length === 0 && supplierSearchTerm && (
                              <div className="px-3 py-2 text-gray-500 text-center">
                                {isUrdu ? 'کوئی سپلائر نہیں ملا' : 'No supplier found'}
                              </div>
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                  {formData.customerPartyId && (
                    <input
                      type="text"
                      value={formData.customerNameUrdu || formData.customerName}
                      onChange={(e) => {
                        handleInputChange('customerNameUrdu', e.target.value);
                        if (!formData.customerNameUrdu) {
                          handleInputChange('customerName', e.target.value);
                        }
                      }}
                      className="w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right mt-2"
                      dir="rtl"
                      placeholder={isUrdu ? 'کسٹمر کا نام' : 'Customer Name'}
                    />
                  )}
                </div>

                {/* Vehicle & Bilty in one row */}
                <div className="mb-3">
                  <div className="flex items-center justify-between gap-4 text-gray-700 flex-wrap" dir="rtl">
                    {/* گاڑی نمبر */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <strong className="whitespace-nowrap">
                        {isUrdu && 'گاڑی نمبر -'}
                      </strong>
                      <input
                        ref={(el) => { inputRefs.current['actualVehicleNumber'] = el; }}
                        type="text"
                        value={formData.actualVehicleNumber}
                        onChange={(e) => handleInputChange('actualVehicleNumber', e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            moveToNextField('actualVehicleNumber');
                          }
                        }}
                        className="w-[120px] max-w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-left"
                        dir="ltr"
                        placeholder={isUrdu ? 'گاڑی نمبر' : 'Vehicle Number'}
                      />
                    </div>
                    {/* بیلٹی نمبر */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <strong className="whitespace-nowrap">
                        {isUrdu && 'بیلٹی نمبر -'}
                      </strong>
                      <input
                        ref={(el) => { inputRefs.current['vehicleNumber'] = el; }}
                        type="text"
                        value={formData.vehicleNumber}
                        onChange={(e) => handleInputChange('vehicleNumber', e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            moveToNextField('vehicleNumber');
                          }
                        }}
                        className="w-[120px] max-w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-left"
                        dir="ltr"
                        placeholder={isUrdu ? 'پلیٹی نمبر' : 'Plate Number'}
                      />
                    </div>
                  </div>
                </div>

                {/* چیز کا نام (Item Name) + Unit + Quantity + گاڑی نمبر (Gardi Number) in same row */}
                <div className="mb-3">
                  <div className="flex items-center justify-between gap-4 text-gray-700 flex-wrap" dir="rtl">
                    {/* چیز کا نام */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <strong className="whitespace-nowrap">
                        {isUrdu ? 'چیز کا نام -' : 'Item Name -'}
                        <span className="text-red-500 ml-1">*</span>
                      </strong>
                      <select
                        ref={(el) => { inputRefs.current['itemName'] = el; }}
                        value={formData.itemName}
                        onChange={(e) => handleInputChange('itemName', e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            moveToNextField('itemName');
                          }
                        }}
                        className="w-[200px] max-w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right"
                        dir="rtl"
                        required
                      >
                        <option value="">{isUrdu ? 'چیز کا نام منتخب کریں' : 'Select Item Name'}</option>
                        {pakistaniFruits.map((fruit) => (
                          <option key={fruit.value} value={fruit.value}>
                            {isUrdu ? fruit.label : fruit.labelEn}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Unit Selection */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <strong className="whitespace-nowrap">
                        {isUrdu ? 'یونٹ' : 'Unit'}
                        <span className="text-red-500 ml-1">*</span>
                      </strong>
                      <select
                        ref={(el) => { inputRefs.current['itemUnit'] = el; }}
                        value={formData.itemUnit}
                        onChange={(e) => handleInputChange('itemUnit', e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            moveToNextField('itemUnit');
                          }
                        }}
                        className="w-[120px] max-w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right"
                        dir="rtl"
                        required
                      >
                        <option value="">{isUrdu ? 'یونٹ' : 'Unit'}</option>
                        <option value="pali">{isUrdu ? 'پلی' : 'Pali'}</option>
                        <option value="paiti">{isUrdu ? 'پیتی' : 'Paiti'}</option>
                        <option value="bags">{isUrdu ? 'بوریاں' : 'Bags'}</option>
                      </select>
                    </div>
                    {/* Quantity Field */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <strong className="whitespace-nowrap">
                        {isUrdu ? 'مقدار' : 'Quantity'}
                      </strong>
                      <input
                        ref={(el) => { inputRefs.current['itemQuantity'] = el; }}
                        type="number"
                        value={formData.itemQuantity}
                        onChange={(e) => handleInputChange('itemQuantity', e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            // Move to commission percentage field
                            const commissionRef = inputRefs.current['commissionPercentage'];
                            if (commissionRef) {
                              setTimeout(() => {
                                commissionRef.focus();
                                if (commissionRef.select) commissionRef.select();
                              }, 10);
                            }
                          }
                          // Prevent arrow keys from incrementing/decrementing
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        className="w-[100px] max-w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                        dir="rtl"
                        placeholder={isUrdu ? 'مقدار' : 'Qty'}
                        min="0"
                        step="1"
                      />
                    </div>
                    {/* Commission Percentage Field */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <strong className="whitespace-nowrap">
                        {isUrdu ? 'کمیشن فیصد' : 'Commission %'}
                      </strong>
                      <input
                        ref={(el) => { inputRefs.current['commissionPercentage'] = el; }}
                        type="number"
                        step="0.01"
                        value={commissionPercentage}
                        onChange={(e) => handleCommissionPercentageChange(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            // Move to Raw Sale field
                            const rawSaleRef = inputRefs.current['Raw Sale'];
                            if (rawSaleRef) {
                              setTimeout(() => {
                                rawSaleRef.focus();
                                if (rawSaleRef.select) rawSaleRef.select();
                              }, 10);
                            } else {
                              moveToNextField('commissionPercentage');
                            }
                          }
                          // Prevent arrow keys from incrementing/decrementing
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        className="w-[100px] max-w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                        dir="rtl"
                        placeholder={isUrdu ? 'مثلاً 5' : 'e.g. 5'}
                      />
                    </div>
                    {/* گاڑی نمبر (Gardi Number) - Display value */}
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <strong className="whitespace-nowrap">{isUrdu ? 'گاڑی نمبر -' : 'Gardi Number -'}</strong>
                      <span className="w-[120px] max-w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-left bg-gray-50 inline-block" dir="ltr">
                        {formData.actualVehicleNumber || ''}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Expenses Section */}
            <div className="mb-6 p-6">
              <div className="flex justify-end mb-4">
                {isUrdu && (
                  <h2 className="text-xl font-bold text-red-600 text-right" dir="rtl">تفصیل اخراجات -</h2>
                )}
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {/* Left Column - Sales Summary */}
                <div className="mt-[8rem] pl-6 pr-6">
                  <div className="space-y-3">
                    {salesFields.length > 0 ? (
                      salesFields.map((field, idx) => (
                        <div key={idx} className="flex items-end justify-between gap-6">
                          <div className="text-right flex-1 pr-6">
                            <label className="block text-sm font-medium text-red-600 mb-1">
                              {isUrdu ? (field.fieldNameUrdu || field.fieldName) : field.fieldName}
                              {field.isRequired && <span className="text-red-500 ml-1">*</span>}
                            </label>
                          </div>
                          <div className="min-w-[60px] text-right">
                            <input
                              ref={(el) => { inputRefs.current[field.fieldName] = el; }}
                              type="number"
                              step="0.01"
                              value={focusedSalesField === field.fieldName && (formData.sales[field.fieldName] === 0 || formData.sales[field.fieldName] === '0') ? '' : (formData.sales[field.fieldName] || '')}
                              onChange={(e) => handleSalesChange(field.fieldName, e.target.value)}
                              onFocus={() => handleSalesFocus(field.fieldName)}
                              onBlur={() => handleSalesBlur(field.fieldName)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  moveToNextField(field.fieldName);
                                }
                                // Prevent arrow keys from incrementing/decrementing
                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                  e.preventDefault();
                                }
                              }}
                              className="w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                              required={field.isRequired}
                            />
                          </div>
                        </div>
                      ))
                    ) : (
                      <>
                        {/* خام بِکری (Raw Sale) */}
                        <div className="flex items-end justify-between gap-6">
                          <div className="text-right flex-1 pr-6">
                            <label className="block text-sm font-medium text-red-600 mb-1">
                              {isUrdu ? 'خام بِکری' : 'Raw Sale'}
                              <span className="text-red-500 ml-1">*</span>
                            </label>
                          </div>
                          <div className="min-w-[60px] text-right">
                            <input
                              ref={(el) => { inputRefs.current['Raw Sale'] = el; }}
                              type="number"
                              step="0.01"
                              value={typeof formData.sales['Raw Sale'] === 'string' ? formData.sales['Raw Sale'] : (formData.sales['Raw Sale'] === 0 || formData.sales['Raw Sale'] === '0' ? '' : (formData.sales['Raw Sale'] || ''))}
                              onChange={(e) => handleSalesChange('Raw Sale', e.target.value)}
                              onFocus={() => handleSalesFocus('Raw Sale')}
                              onBlur={() => handleSalesBlur('Raw Sale')}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  // Move to Cash field
                                  const cashRef = inputRefs.current['Cash'];
                                  if (cashRef) {
                                    setTimeout(() => {
                                      cashRef.focus();
                                      if (cashRef.select) cashRef.select();
                                    }, 10);
                                  } else {
                                    moveToNextField('Raw Sale');
                                  }
                                }
                                // Prevent arrow keys from incrementing/decrementing
                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                  e.preventDefault();
                                }
                              }}
                              className="w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                              required
                            />
                          </div>
                        </div>

                        {/* اخراجات (Total Expenses) - read only */}
                        <div className="flex items-end justify-between gap-6">
                          <div className="text-right flex-1 pr-6">
                            <label className="block text-sm font-medium text-red-600 mb-1">
                              {isUrdu ? 'اخراجات' : 'Expenses'}
                            </label>
                          </div>
                          <div className="min-w-[60px] text-right">
                            <span className="w-full inline-block px-2 py-1 border border-gray-300 rounded text-gray-700 text-right bg-gray-50">
                              {totalExpenses.toLocaleString()}
                            </span>
                          </div>
                        </div>

                        {/* پختہ بِکری (Net Sale) - read only */}
                        <div className="flex items-end justify-between gap-6">
                          <div className="text-right flex-1 pr-6">
                            <label className="block text-sm font-medium text-red-600 mb-1">
                              {isUrdu ? 'پختہ بِکری' : 'Net Sale'}
                            </label>
                          </div>
                          <div className="min-w-[60px] text-right">
                            <span className="w-full inline-block px-2 py-1 border border-gray-300 rounded text-gray-700 text-right bg-gray-50">
                              {netSale.toLocaleString()}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* Right Column - Expense Fields */}
                <div className="space-y-3 text-right pr-12" dir="rtl">
                  {expenseFields.length > 0 ? (
                    expenseFields
                      .filter(f => f.fieldName !== 'Vehicle' && f.fieldNameUrdu !== 'گاڑی')
                      .map((field, idx) => {
                        const isCashField = field.fieldName === 'Cash' || field.fieldName === 'نقدی';
                        return (
                          <div key={idx} className="flex justify-between items-center gap-6">
                            <div className="flex-1 text-right">
                              <label className="text-gray-700 font-medium">
                                {isUrdu ? (field.fieldNameUrdu || field.fieldName) : field.fieldName}.
                                {!isCashField && <span className="text-red-500 ml-1">*</span>}
                              </label>
                              {isCashField && formData.customerPartyId && (
                                <div className="text-xs text-gray-500 mt-1">
                                  {isUrdu ? 'دستیاب بیلنس:' : 'Available Balance:'} {selectedCustomerBalance.toLocaleString()}
                                </div>
                              )}
                              {isCashField && cashAmountError && (
                                <div className="text-xs text-red-600 mt-1">{cashAmountError}</div>
                              )}
                            </div>
                            <div className="min-w-[50px] text-right">
                              <input
                                ref={(el) => { inputRefs.current[field.fieldName] = el; }}
                                type="number"
                                step="0.01"
                                value={typeof formData.expenses[field.fieldName] === 'string' ? formData.expenses[field.fieldName] : (formData.expenses[field.fieldName] === 0 || formData.expenses[field.fieldName] === '0' ? '' : (formData.expenses[field.fieldName] || ''))}
                                onChange={(e) => handleExpenseChange(field.fieldName, e.target.value)}
                                onFocus={() => handleExpenseFocus(field.fieldName)}
                                onBlur={() => handleExpenseBlur(field.fieldName)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault();
                                    moveToNextField(field.fieldName);
                                  }
                                  // Prevent arrow keys from incrementing/decrementing
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className={`w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ${isCashField && cashAmountError ? 'border-red-500' : ''}`}
                                required={!isCashField}
                              />
                            </div>
                          </div>
                        );
                      })
                  ) : (
                    <>
                      {/* Default Expense fields when admin-side config empty - exactly as per image */}
                      {/* 1. نقدی (Cash) */}
                      <div className="flex justify-between items-center gap-6">
                        <div className="flex-1 text-right">
                          <label className="text-gray-700 font-medium">
                            {isUrdu ? 'نقدی' : 'Cash'}.
                          </label>
                          {formData.customerPartyId && (
                            <div className="text-xs text-gray-500 mt-1">
                              {isUrdu ? 'دستیاب بیلنس:' : 'Available Balance:'} {selectedCustomerBalance.toLocaleString()}
                            </div>
                          )}
                          {cashAmountError && (
                            <div className="text-xs text-red-600 mt-1">{cashAmountError}</div>
                          )}
                        </div>
                        <div className="min-w-[50px] text-right">
                          <input
                            ref={(el) => { inputRefs.current['Cash'] = el; }}
                            type="number"
                            step="0.01"
                            value={typeof formData.expenses['Cash'] === 'string' ? formData.expenses['Cash'] : (formData.expenses['Cash'] === 0 || formData.expenses['Cash'] === '0' ? '' : (formData.expenses['Cash'] || ''))}
                            onChange={(e) => handleExpenseChange('Cash', e.target.value)}
                            onFocus={() => handleExpenseFocus('Cash')}
                            onBlur={() => handleExpenseBlur('Cash')}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                moveToNextField('Cash');
                              }
                              // Prevent arrow keys from incrementing/decrementing
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className={`w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ${cashAmountError ? 'border-red-500' : ''}`}
                          />
                        </div>
                      </div>

                      {/* 2. کرایه (Rent/Fare) */}
                      <div className="flex justify-between items-center gap-6">
                        <div className="flex-1 text-right">
                          <label className="text-gray-700 font-medium">
                            {isUrdu ? 'کرایه' : 'Rent'}.
                            <span className="text-red-500 ml-1">*</span>
                          </label>
                        </div>
                        <div className="min-w-[50px] text-right">
                          <input
                            ref={(el) => { inputRefs.current['Rent'] = el; }}
                            type="number"
                            step="0.01"
                            value={typeof formData.expenses['Rent'] === 'string' ? formData.expenses['Rent'] : (formData.expenses['Rent'] === 0 || formData.expenses['Rent'] === '0' ? '' : (formData.expenses['Rent'] || ''))}
                            onChange={(e) => handleExpenseChange('Rent', e.target.value)}
                            onFocus={() => handleExpenseFocus('Rent')}
                            onBlur={() => handleExpenseBlur('Rent')}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                moveToNextField('Rent');
                              }
                              // Prevent arrow keys from incrementing/decrementing
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            required
                          />
                        </div>
                      </div>

                      {/* 3. کمیشن (Commission) */}
                      <div className="flex justify-between items-center gap-6">
                        <div className="flex-1 text-right">
                          <label className="text-gray-700 font-medium">
                            {isUrdu ? 'کمیشن' : 'Commission'}.
                            <span className="text-red-500 ml-1">*</span>
                          </label>
                        </div>
                        <div className="min-w-[50px] text-right">
                          <input
                            ref={(el) => { inputRefs.current['Commission'] = el; }}
                            type="number"
                            step="0.01"
                            value={typeof formData.expenses['Commission'] === 'string' ? formData.expenses['Commission'] : (formData.expenses['Commission'] === 0 || formData.expenses['Commission'] === '0' ? '' : (formData.expenses['Commission'] || ''))}
                            onChange={(e) => handleExpenseChange('Commission', e.target.value)}
                            onFocus={() => handleExpenseFocus('Commission')}
                            onBlur={() => handleExpenseBlur('Commission')}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                moveToNextField('Commission');
                              }
                              // Prevent arrow keys from incrementing/decrementing
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            required
                          />
                        </div>
                      </div>

                      {/* 4. مزدوری (Wages/Labor) */}
                      <div className="flex justify-between items-center gap-6">
                        <div className="flex-1 text-right">
                          <label className="text-gray-700 font-medium">
                            {isUrdu ? 'مزدوری' : 'Wages'}.
                            <span className="text-red-500 ml-1">*</span>
                          </label>
                        </div>
                        <div className="min-w-[50px] text-right">
                          <input
                            ref={(el) => { inputRefs.current['Labor'] = el; }}
                            type="number"
                            step="0.01"
                            value={typeof formData.expenses['Labor'] === 'string' ? formData.expenses['Labor'] : (formData.expenses['Labor'] === 0 || formData.expenses['Labor'] === '0' ? '' : (formData.expenses['Labor'] || formData.expenses['Wages'] || ''))}
                            onChange={(e) => handleExpenseChange('Labor', e.target.value)}
                            onFocus={() => handleExpenseFocus('Labor')}
                            onBlur={() => handleExpenseBlur('Labor')}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                moveToNextField('Labor');
                              }
                              // Prevent arrow keys from incrementing/decrementing
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            required
                          />
                        </div>
                      </div>

                      {/* 5. مشیانه (Mashiyana) */}
                      <div className="flex justify-between items-center gap-6">
                        <div className="flex-1 text-right">
                          <label className="text-gray-700 font-medium">
                            {isUrdu ? 'مشیانه' : 'Mashiyana'}.
                            <span className="text-red-500 ml-1">*</span>
                          </label>
                        </div>
                        <div className="min-w-[50px] text-right">
                          <input
                            ref={(el) => { inputRefs.current['Miscellaneous'] = el; }}
                            type="number"
                            step="0.01"
                            value={typeof formData.expenses['Miscellaneous'] === 'string' ? formData.expenses['Miscellaneous'] : (formData.expenses['Miscellaneous'] === 0 || formData.expenses['Miscellaneous'] === '0' ? '' : (formData.expenses['Miscellaneous'] || formData.expenses['Mashiyana'] || ''))}
                            onChange={(e) => handleExpenseChange('Miscellaneous', e.target.value)}
                            onFocus={() => handleExpenseFocus('Miscellaneous')}
                            onBlur={() => handleExpenseBlur('Miscellaneous')}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                moveToNextField('Miscellaneous');
                              }
                              // Prevent arrow keys from incrementing/decrementing
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            required
                          />
                        </div>
                      </div>

                      {/* 6. مارکیٹ فیس (Market Fee) */}
                      <div className="flex justify-between items-center gap-6">
                        <div className="flex-1 text-right">
                          <label className="text-gray-700 font-medium">
                            {isUrdu ? 'مارکیٹ فیس' : 'Market Fee'}.
                            <span className="text-red-500 ml-1">*</span>
                          </label>
                        </div>
                        <div className="min-w-[50px] text-right">
                          <input
                            ref={(el) => { inputRefs.current['Market Fee'] = el; }}
                            type="number"
                            step="0.01"
                            value={typeof formData.expenses['Market Fee'] === 'string' ? formData.expenses['Market Fee'] : (formData.expenses['Market Fee'] === 0 || formData.expenses['Market Fee'] === '0' ? '' : (formData.expenses['Market Fee'] || ''))}
                            onChange={(e) => handleExpenseChange('Market Fee', e.target.value)}
                            onFocus={() => handleExpenseFocus('Market Fee')}
                            onBlur={() => handleExpenseBlur('Market Fee')}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                moveToNextField('Market Fee');
                              }
                              // Prevent arrow keys from incrementing/decrementing
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="w-full px-2 py-1 border border-gray-300 rounded text-gray-700 text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            required
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <div className="flex justify-between items-center border-t-2 border-gray-400 py-3 mt-3 gap-6">
                    <div className="flex-1 text-right pr-6">
                      <label className="font-bold text-red-600 text-lg">
                        {isUrdu ? 'کل رقم -' : 'Total Amount -'}
                      </label>
                    </div>
                    <div className="min-w-[60px] text-right">
                      <span className="font-bold text-gray-900 text-lg">{totalExpenses.toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="p-6 border-t border-gray-300 flex justify-end gap-4">
              <button
                type="button"
                onClick={() => navigate('/company/dashboard')}
                className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
              >
                {isUrdu ? 'منسوخ' : 'Cancel'}
              </button>
              <button
                type="submit"
                disabled={isSaving}
                className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg disabled:opacity-50"
              >
                {isSaving
                  ? (isUrdu ? (isEditMode ? 'تبدیل کر رہے ہیں...' : 'بنا رہے ہیں...') : (isEditMode ? 'Updating...' : 'Creating...'))
                  : (isUrdu ? (isEditMode ? 'بل تبدیل کریں' : 'بل بنائیں') : (isEditMode ? 'Update Bill' : 'Create Bill'))}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Urdu Keyboard for Supplier Search */}
      <UrduKeyboard
        isVisible={showSupplierUrduKeyboard}
        onKeyPress={handleSupplierSearchUrduKeyPress}
        onClose={() => setShowSupplierUrduKeyboard(false)}
      />
    </>
  );
}

export default CreateBill;

